import formatMoney from '@/misc/formatMoney';

export default function getDonationOptionTitle({ title, prices, currency }) {
  if (prices.length === 0) return title;

  if (prices.length === 1) {
    const price = prices[0];
    return `${title} - ${formatMoney(price.amount, price.currency)}`;
  }

  const formattedPrices = prices.map((price) =>
    formatMoney(price.amount, currency, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    })
  );

  return `${title} - ${formattedPrices
    .slice(0, -1)
    .join(', ')} or ${formattedPrices.slice(-1)}`;
}
